import moment from 'moment';
import React, {useMemo} from 'react';

import {IUseCustomTableArgs} from 'components/@common/widgets/custom-table/custom-table';
import {DATE_DMY} from 'shared/constants/date-format';

import {IOrgInfoDto} from '../api/types';
import {EditOrgInfoForm} from '../ui/forms/org-info-form/edit-modal-org-info-form';

export const useOrgInfoColumns = (
    tableData: IOrgInfoDto[] | undefined,
    fetchData: () => Promise<void>
): IUseCustomTableArgs['columns'] =>
    useMemo(
        () => [
            {
                title: 'Код ГК',
                dataIndex: 'companyGroupCode',
                render: (value: number, fields: IOrgInfoDto) => (
                    <EditOrgInfoForm
                        fields={fields}
                        value={value}
                        fetchData={fetchData}
                    />
                ),
            },
            {title: 'ИНН организации', dataIndex: 'inn'},
            {
                title: 'Дата начала',
                dataIndex: 'startDate',
                render: (item) => item !== null && moment(item).format(DATE_DMY),
            },
            {
                title: 'Дата окончания',
                dataIndex: 'endDate',
                render: (item) => item !== null && moment(item).format(DATE_DMY),
            },
        ],
        [tableData]
    );
